<p-table
  #dt1
  [value]="operations"
  dataKey="id"
  [rows]="50"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  [loading]="loading"
  styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="true"
  currentPageReportTemplate="Prikaz od {first}. do {last}. operacije od ukupno {totalRecords}"
  [globalFilterFields]="['label', 'name']"
>
  <ng-template pTemplate="caption">
    <div class="page-control">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          (input)="dt1.filterGlobal($event.target.value, 'contains')"
          placeholder="Pretraži oznaku ili naziv"
        />
      </span>
      <div class="btn-group">
        <a [routerLink]="['add']" class="main-btn"
          >Dodaj operaciju <i class="pi pi-plus"></i>
        </a>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4.5rem"></th>
      <th pSortableColumn="label">
        <div class="flex justify-content-between align-items-center">
          Oznaka operacije
          <p-sortIcon field="label"></p-sortIcon>
          <!-- <p-columnFilter type="text" field="name" display="menu"></p-columnFilter> -->
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Naziv operacije
          <!-- <p-columnFilter type="text" field="name" display="menu"></p-columnFilter> -->
        </div>
      </th>

      <th style="width: 8rem">
        <div class="flex justify-content-between align-items-center">
          Akcija
        </div>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-operations let-expanded="expanded">
    <tr>
      <td>
        <button
          type="button"
          pButton
          [pRowToggler]="operations"
          class="p-button-text p-button-rounded p-button-plain"
          [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
        ></button>
      </td>
      <td>
        {{ operations.label }}
      </td>
      <td>
        <span class="image-text">{{ operations.name }}</span>
      </td>

      <td class="text-center">
        <a
          class="second-btn small-btn mr-2"
          pTooltip="Izmeni"
          tooltipPosition="top"
          (click)="onEditOperation(operations)"
          [routerLink]="['edit']"
        >
          <i class="pi pi-pencil"></i>
        </a>
        <button
          class="second-btn small-btn"
          type="button"
          pTooltip="Izbriši"
          tooltipPosition="top"
          (click)="onDeleteOperation($event, operations.id)"
        >
          <i class="pi pi-trash"></i>
        </button>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="rowexpansion" let-operations>
    <tr>
      <td colspan="4">
        <div class="p-pt-0 mb-4 subtable">
          <p-table [value]="operations.suboperations" dataKey="id">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="label">
                  Oznaka podoperacije <p-sortIcon field="price"></p-sortIcon>
                </th>
                <th>Naziv podoperacije</th>
                <th>Cena rada</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-suboperation>
              <tr>
                <td>{{ suboperation.label }}</td>
                <td>{{ suboperation.name }}</td>
                <td>{{ suboperation.cost }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="4">Ova operacija nema ni jednu podoperaciju.</td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="4">Ni jedna operacija nije pronađena.</td>
    </tr>
  </ng-template>
</p-table>
